module.exports = [
  // {
  //     type: Object,
  //     isHeader: false,
  //     icon: 'fa el-icon-edit',
  //     name: 'จัดการ',
  //     items: [{
  //         name: ['Manage_user'],
  //         name_th: 'จัดการผู้ใช้งาน (Users)',
  //         icon: 'fa el-icon-user',
  //         router: { name: '/Admin/Manage_user' },
  //         link: '/Admin/Manage_user'
  //     }, {
  //         name: ['Manage_admin'],
  //         name_th: 'จัดการผู้ดูแลระบบ (Admin)',
  //         icon: 'fa fa-user',
  //         router: { name: '/Admin/Manage_admin' },
  //         link: '/Admin/Manage_admin'
  //     }]
  // },{
  //     type: Object,
  //     isHeader: false,
  //     icon: 'fa fa-bar-chart-o',
  //     name: 'รายงาน',
  //     items: [{
  //         name: ['Promotion_table_avg'],
  //         name_th: 'รายงานตารางรายการส่งเสริมการขายค่าเฉลี่ยค่าบริการและการเปลี่ยนแปลงอัตราค่าบริการในไตรมาส',
  //         icon: 'fa fa-building-o',
  //         router: { name: '/Admin/Promotion_table_avg' },
  //         link: '/Admin/Promotion_table_avg'
  //     }]
  // }
  // {
  //     type: Object,
  //     isHeader: false,
  //     icon: 'fa el-icon-more',
  //     name_th: 'จัดการ',
  //     items: [{
  //         name: ['Manage_user'],
  //         name_th: 'จัดการผู้ใช้งาน (Users)',
  //         icon: 'fa el-icon-user',
  //         router: { name: '/Admin/Manage_user' },
  //         link: '/Admin/Manage_user'
  //     }, {
  //         name: ['Manage_admin'],
  //         name_th: 'จัดการผู้ดูแลระบบ (Admin)',
  //         icon: 'fa fa-user',
  //         router: { name: '/Admin/Manage_admin' },
  //         link: '/Admin/Manage_admin'
  //     }]
  // },
  {
    type: Object,
    isHeader: false,
    name: ['Manage_user'],
    name_th: 'จัดการผู้ใช้งาน (Users)',
    icon: 'fa el-icon-user',
    router: { name: '/Admin/Manage_user' },
    link: '/Admin/Manage_user',
  }, {
    type: Object,
    isHeader: false,
    name: ['Manage_admin', 'Add_admin', 'Edit_admin'],
    name_th: 'จัดการผู้ดูแลระบบ (Admin)',
    icon: 'fa fa-user',
    router: { name: '/Admin/Manage_admin' },
    link: '/Admin/Manage_admin',
  }, {
    type: Object,
    isHeader: false,
    name: ['Manage_operator', 'Add_operator', 'Edit_operator'],
    name_th: 'จัดการผู้ให้บริการ (Operator)',
    icon: 'fa el-icon-s-custom',
    router: { name: '/Admin/Manage_operator' },
    link: '/Admin/Manage_operator',
  }, {
    type: Object,
    isHeader: false,
    name: ['Manage_terms_and_condition'],
    name_th: 'จัดการเงื่อนไขการให้บริการ',
    icon: 'fa el-icon-s-order',
    router: { name: '/Admin/Manage_terms_and_condition' },
    link: '/Admin/Manage_terms_and_condition',
  }, {
    type: Object,
    isHeader: false,
    name: ['Manage_privacy_data_policy'],
    name_th: 'จัดการข้อกำหนดและนโยบายข้อมูลส่วนบุคคล',
    icon: 'fa el-icon-s-order',
    router: { name: '/Admin/Manage_privacy_data_policy' },
    link: '/Admin/Manage_privacy_data_policy',
  }, {
    type: Object,
    isHeader: false,
    name: ['Manage_security_policy'],
    name_th: 'จัดการนโยบายด้านความปลอดภัย',
    icon: 'fa el-icon-s-order',
    router: { name: '/Admin/Manage_security_policy' },
    link: '/Admin/Manage_security_policy',
  }, {
    type: Object,
    isHeader: false,
    name: ['Manage_cookie_privacy'],
    name_th: 'จัดการนโยบายคุกกี้',
    icon: 'fa el-icon-s-order',
    router: { name: '/Admin/Manage_cookie_privacy' },
    link: '/Admin/Manage_cookie_privacy',
  }, {
    type: Object,
    isHeader: false,
    name: ['Manage_question', 'Manage_question_add', 'Manage_questionEdit'],
    name_th: 'จัดการคำถามที่พบบ่อย',
    icon: 'fa el-icon-s-order',
    router: { name: '/Admin/Manage_question' },
    link: '/Admin/Manage_question',
  }, {
    type: Object,
    isHeader: false,
    name: ['Manage_article', 'Manage_article_add', 'Manage_articleEdit'],
    name_th: 'จัดการบทความ',
    icon: 'fa el-icon-s-order',
    router: { name: '/Admin/Manage_article' },
    link: '/Admin/Manage_article',
  }, {
    type: Object,
    isHeader: false,
    name: ['Manage_news', 'Manage_news_add', 'Manage_news_edit'],
    name_th: 'จัดการข่าวสาร',
    icon: 'fa el-icon-s-order',
    router: { name: '/Admin/Manage_news' },
    link: '/Admin/Manage_news',
  }, {
    type: Object,
    isHeader: false,
    name: ['Manage_banner'],
    name_th: 'จัดการป้ายโฆษณา (Banner)',
    icon: 'fa el-icon-s-order',
    router: { name: '/Admin/Manage_banner' },
    link: '/Admin/Manage_banner',
  }, {
    type: Object,
    isHeader: false,
    name: ['Access_log'],
    name_th: 'ประวัติการเข้าใช้งาน (Access Logs)',
    icon: 'fa el-icon-s-custom',
    router: { name: '/Admin/Access_log' },
    link: '/Admin/Access_log',
  }
]
